import "./switch.css";
const Switch = ({ checked, onClick, name }) => {
  return (
    <label
      className="switch"
      data-toggle="tooltip"
      data-placement="top"
      // title={checked ? "monfza" : "garya"}
    >
      <input type="checkbox" checked={checked} onClick={onClick} name={name} />
      <span className="slider round"></span>
    </label>
  );
};

export default Switch;
